export default function CurpValidate(curp) {
  const returnObject = {
    valid: false,
    data: '',
  };
  curp = curp.toUpperCase();
  if (curp.length !== 18) {
    returnObject.valid = false;
    returnObject.data = `Curp invalido: ' ${curp}'`;
    return returnObject;
  }
  const verificador = curp.charAt(curp.length - 1);
  let tParcial = 0;

  for (let i = 0; i < curp.length - 1; i++) {
    let tNumero = 0;
    switch (curp.charAt(i)) {
      case '0': tNumero = 0;
        break;
      case '1': tNumero = 1;
        break;
      case '2': tNumero = 2;
        break;
      case '3': tNumero = 3;
        break;
      case '4': tNumero = 4;
        break;
      case '5': tNumero = 5;
        break;
      case '6': tNumero = 6;
        break;
      case '7': tNumero = 7;
        break;
      case '8': tNumero = 8;
        break;
      case '9': tNumero = 9;
        break;
      case 'A': tNumero = 10;
        break;
      case 'B': tNumero = 11;
        break;
      case 'C': tNumero = 12;
        break;
      case 'D': tNumero = 13;
        break;
      case 'E': tNumero = 14;
        break;
      case 'F': tNumero = 15;
        break;
      case 'G': tNumero = 16;
        break;
      case 'H': tNumero = 17;
        break;
      case 'I': tNumero = 18;
        break;
      case 'J': tNumero = 19;
        break;
      case 'K': tNumero = 20;
        break;
      case 'L': tNumero = 21;
        break;
      case 'M': tNumero = 22;
        break;
      case 'N': tNumero = 23;
        break;
      case 'Ñ': tNumero = 24;
        break;
      case 'O': tNumero = 25;
        break;
      case 'P': tNumero = 26;
        break;
      case 'Q': tNumero = 27;
        break;
      case 'R': tNumero = 28;
        break;
      case 'S': tNumero = 29;
        break;
      case 'T': tNumero = 30;
        break;
      case 'U': tNumero = 31;
        break;
      case 'V': tNumero = 32;
        break;
      case 'W': tNumero = 33;
        break;
      case 'X': tNumero = 34;
        break;
      case 'Y': tNumero = 35;
        break;
      case 'Z': tNumero = 36;
        break;
      case ' ': tNumero = 37;
        break;
      default: tNumero = 0;
    }
    tParcial += tNumero * (18 - i);
  }
  const tMod = tParcial % 10;
  let ultimo = '';
  if (tMod === 0) {
    ultimo = '0';
  } else {
    tParcial = 10 - tMod;
    if (tParcial === 10) {
      ultimo = 'A';
    } else {
      ultimo = tParcial.toString(10);
    }
  }
  if (ultimo === verificador) {
    returnObject.valid = true;
    returnObject.data = curp;
    return returnObject;
  }
  returnObject.valid = false;
  returnObject.data = `Curp invalido: '${curp}' [${ultimo}]`;
  return returnObject;
};
